import { useQuery } from "react-query";
import { createApiWithPath } from "../../client";
import { queryKeys } from "../../query";
import { TallyFormDetailResponseData } from "../../types/tally";

const fetchTallyForm = async (
  id: string,
): Promise<TallyFormDetailResponseData> => {
  const { data } = await createApiWithPath(
    "tally",
  ).get<TallyFormDetailResponseData>(`/forms/${id}`);

  return data;
};

export const useTallyForm = (id?: string) => {
  return useQuery(queryKeys.tallyForm(id), () => fetchTallyForm(id as string), {
    enabled: !!id,
    refetchOnMount: "always",
  });
};
